// Speaks text out loud using the browser's built-in speech synthesis — no
// external service, so it works inside the prototype. Cancels anything already
// playing so a replay never overlaps. No-ops where the API isn't available.
export const speak = (text: string) => {
  if (typeof window === 'undefined' || !('speechSynthesis' in window)) return;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.rate = 1;
  utterance.pitch = 1;
  window.speechSynthesis.speak(utterance);
};
